import {
  DeviceResponseReportWrapper,
} from "src/repositories/api/dto/DeviceResponseReportWrapper";
import { globalAxiosAction } from "src/repositories/api/Init.api";
import { createDefaultAxios } from "src/repositories/api/Utils/AxiosUtility";
import {
  GeneralApiResponse,
  handleGeneralApiError,
} from "src/repositories/api/Utils/ResponseUtility";
import { getBrearerTokenHeader } from "src/repositories/api/Utils/Utils.api";
import {
  createSuccessResponse,
} from "src/repositories/model/FailableResponse";

const axiosInstance = createDefaultAxios("/api/physicalDevices/");
globalAxiosAction.subscribe(axiosInstance);

function getApiPath(deviceSn: string, rest?: string) {
  return `${deviceSn}/timeWindows${rest == null ? "" : `/${rest}`}`;
}

async function get(
  deviceSn: string
): Promise<GeneralApiResponse<DeviceResponseReportWrapper>> {
  try {
    const response = await axiosInstance.get<DeviceResponseReportWrapper>(
      getApiPath(deviceSn),
      getBrearerTokenHeader()
    );
    return createSuccessResponse(response.data);
  } catch (e) {
    return handleGeneralApiError(e);
  }
}

async function upload(
  deviceSn: string
): Promise<
  GeneralApiResponse<DeviceResponseReportWrapper<TimeWindowGroup[] | undefined>>
> {
  try {
    const response = await axiosInstance.post<
      DeviceResponseReportWrapper<TimeWindowGroup[] | undefined>
    >(getApiPath(deviceSn, "upload"), null, getBrearerTokenHeader());
    return createSuccessResponse(response.data);
  } catch (e) {
    return handleGeneralApiError(e);
  }
}

async function download(
  deviceSn: string
): Promise<GeneralApiResponse<DeviceResponseReportWrapper>> {
  try {
    const response = await axiosInstance.post<DeviceResponseReportWrapper>(
      getApiPath(deviceSn, "download"),
      null,
      getBrearerTokenHeader()
    );
    return createSuccessResponse(response.data);
  } catch (e) {
    return handleGeneralApiError(e);
  }
}

export const physicalDeviceTimeWindowGroupsApi = {
  get,
  upload,
  download
};
